import { type FC } from 'react'
import { Col, Row } from 'react-bootstrap'

interface SchedulingFlowHeaderProps {
  title: string
  onBack: () => void
}

export const SchedulingFlowHeader: FC<SchedulingFlowHeaderProps> = ({ title, onBack }) => (
  <Row className='align-items-center mb-4'>
    <Col xs='auto'>
      <button type='button' aria-label='Go back' className='btn btn-link p-0 border-0 d-inline-flex align-items-center zocks-text-gray-900' onClick={onBack}>
        <i className='bi bi-chevron-left' aria-hidden='true' />
      </button>
    </Col>
    <Col>
      <h3 className='mb-0'>{title}</h3>
    </Col>
  </Row>
)
